const e = {
  fixed: !1,
  inverted: !1,
  mainId: "#main",
  footerId: "#footer"
};
export { e as headerDefaultProps };